<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            placeholder="请输入购销计划"
          />
        </el-form-item>
        <el-form-item
          label="成交日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始成交日期"
            end-placeholder="截止成交日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="totalAmount"
        label="总成交量"
      />
      <af-table-column
        prop="signBuySumAmount"
        label="采购订立量"
      />
      <af-table-column
        prop="signBuyAvgPrice"
        label="采购订立均价"
      />
      <af-table-column
        prop="transferBuySumAmount"
        label="变更采购量"
      />
      <af-table-column
        prop="transferBuyAvgPrice"
        label="变更采购均价"
      />
      <af-table-column
        prop="signSellSumAmount"
        label="销售订立量"
      />
      <af-table-column
        prop="signSellAvgPrice"
        label="销售订立均价"
      />
      <af-table-column
        prop="transferSellSumAmount"
        label="变更销售量"
      />
      <af-table-column
        prop="transferSellAvgPrice"
        label="变更销售均价"
      />
      <af-table-column
        prop="presentChangeWarehouse"
        label="变今仓量"
      />
      <af-table-column
        prop="unPresentChangeWarehouse"
        label="非变今仓量"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司名称"
      />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span
            class="detail-color"
            @click="open(scope.row)"
          >详情</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <!-- 详情 -->
    <detail
      v-if="isShow"
      :row="row"
      @shutDown="shutDown"
    />
  </div>
</template>
<script>
import detail from './components/detail'
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织
  this.goodsCode = '' // 购销计划
  this.date = [] // 成交日期
}
export default {
  name: 'HistoricalTransactioninquiry',
  components: {
    detail
  },
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
      row: {},
      marketId: '',
      isShow: false,

    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.startDate = this.query.date.length ? dayJs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endDate = this.query.date.length ? dayJs(this.query.date[1]).format('YYYYMMDD') : ''
      let res = await api.spotPurchaseSaleInquiry.HistoricalTransactioninquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    open (row) {
      this.row = row
      this.isShow = true
    },
    // 关闭弹窗
    shutDown () {
      this.isShow = false
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '15',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '成交日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '区域',
            excelColumn: 'areaName'
          },
          {
            fieldLabel: '购销计划',
            excelColumn: 'goodsCode'
          },
          {
            fieldLabel: '总成交量',
            excelColumn: 'totalAmount'
          },
          {
            fieldLabel: '采购订立量',
            excelColumn: 'signBuySumAmount'
          },
          {
            fieldLabel: '采购订立均价',
            excelColumn: 'signBuyAvgPrice'
          },
          {
            fieldLabel: '变更采购量',
            excelColumn: 'transferBuySumAmount'
          },
          {
            fieldLabel: '变更采购均价',
            excelColumn: 'transferBuyAvgPrice'
          },
          {
            fieldLabel: '销售订立量',
            excelColumn: 'signSellSumAmount'
          },
          {
            fieldLabel: '销售订立均价',
            excelColumn: 'signSellAvgPrice'
          },
          {
            fieldLabel: '变更销售量',
            excelColumn: 'transferSellSumAmount'
          },
          {
            fieldLabel: '变更销售均价',
            excelColumn: 'transferSellAvgPrice'
          },
          {
            fieldLabel: '变今仓量',
            excelColumn: 'presentChangeWarehouse'
          },
          {
            fieldLabel: '非变今仓量',
            excelColumn: 'unPresentChangeWarehouse'
          },
          {
            fieldLabel: '贸易公司名称',
            excelColumn: 'tradeCompanyCode'
          }
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child {

    td:last-child div,
    td:nth-child(10) div,
    td:nth-child(12) div,
    td:nth-child(14) div,
    td:nth-child(16) div {
      display: none;
    }
  }

  .hideTotal ::v-deep .el-table__fixed-body-wrapper:first-child tbody tr:last-child {
    td:nth-child(2) div {
      display: none
    }

  }

</style>
